var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('iframe',{staticStyle:{"position":"relative","top":"-150px","z-index":"0"},attrs:{"type":"text/html","width":"100%","height":"700","src":"https://rank.supermembers.co.kr/rank/show","frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }